const validators = {};

export default validators;



// WEBPACK FOOTER //
// ./src/modules/store-profiles/validators/action-validators.js